import axios from "axios";

export default {
    getProfile: async (personId) => {
        const { data } = await axios.get(`/profile/new/${personId}`)
        return data
    },
    getProfileFlextimeSettings: async (companyId, personId) => {
        const { data } = await axios.get(`/profile/new/flextime_settings/${companyId}/${personId}`)
        return data
    },
    getProfileOld: async (accountId) => {
        const { data } = await axios.get(`/profile/${accountId}`, { params: {
            for_edit: 1
        }})
        return data
    },
    postProfileAvatar: async (file, filename) => {
        const form_data = new FormData();
        form_data.append("userfile", file);
        form_data.append("userfilename", filename);

        const { data } = await axios.post(`/profile_avatar/`, form_data)
        return data
    }
}
